import { ServerStats } from '@common/types';

export const formatBites = (bytes: number) => {
  if (bytes === 0) return '0b';

  const k = 1000;
  const sizes = ['b', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(2));

  return `${formattedSize}${sizes[i] || 'b'}`;
};

export const formatBytes = (bytes: number) => {
  if (bytes === 0) return '0B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(2));

  return `${formattedSize}${sizes[i] || 'B'}`;
};

export const formatNumber = (n: number) => {
  return n.toFixed(2).toLocaleString();
};

export const formatTwoNumber = (n: number) => {
  return n.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
};

export const getTime = (seconds: number) => {
  let l = seconds;

  const d = Math.floor(l / 86400);
  const days = formatTwoNumber(d);
  l = l - d * 86400;

  const h = Math.floor(l / 3600);
  const hours = formatTwoNumber(h);
  l = l - h * 3600;

  const m = Math.floor(l / 60);
  const minutes = formatTwoNumber(m);
  l = l - m * 60;

  const leftover = formatTwoNumber(l);

  return days + ':' + hours + ':' + minutes + ':' + leftover;
};

export const getService = (value: ServerStats['services']) => {
  if (value?.http_proxy?.active) return 'SSL';
  if (value?.shadowsocks?.active) return 'Shadowsocks';
  if (value?.squid?.active) return 'HTTP';
  return 'No Service';
};

export const timesAgo = (time: number) => {
  const now = new Date().getTime();
  const diff = now - time;
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days}d ago`;
  if (hours > 0) return `${hours}h ago`;
  if (minutes > 0) return `${minutes}m ago`;
  return `${seconds}s ago`;
};
